<div>
  <div class="sign-up-form-explanation sign-up-form-swiper-container">
    <div class="sign-up-form-explanation-title" data-testid="step-one-title">
      {{ (customContent$$ | async)?.formTitle | translate }}
    </div>
    <div class="sign-up-form-explanation-subtitle">
      {{ (customContent$$ | async)?.formSubtitle | translate }}
    </div>
  </div>
  <div>
    <div class="form-container">
      <div>
        @if ((signUpVariant$$ | async) !== 'HACKERONE') {
          <div>
            <div class="row">
              @if (
                (googleOptionSelected$$ | async) === false &&
                (microsoftOptionSelected$$ | async) === false &&
                (linkedOptionSelected$$ | async) === false) {
                <span
                  class="sign-up-buttons-container"
                  >
                  <button
                    data-action="step-one-google-sign-in"
                    type="button"
                    class="google-sign-in"
                    id="googleBtn"
                    (click)="googleSignUpSelection()"
                    data-testid="sign-up-google"
                    >
                    <img src="../../../assets/images/icons/google-logo.png" class="google-logo" alt="Google logo" />
                    <span class="google-sign-in-text">
                      {{ 'SIGNUP.BUTTONS.GOOGLE' | translate }}
                    </span>
                  </button>
                  <button
                    data-action="step-one-microsoft-sign-in"
                    type="button"
                    class="microsoft-sign-in"
                    id="microsoftBtn"
                    (click)="microsoftSignUpSelection()"
                    data-testid="sign-up-microsoft"
                    >
                    <img
                      src="../../../assets/images/icons/microsoft-logo.png"
                      class="microsoft-logo"
                      alt="microsoft logo"
                      />
                    <span class="microsoft-sign-in-text">
                      {{ 'SIGNUP.BUTTONS.MICROSOFT' | translate }}
                    </span>
                  </button>
                  <button
                    data-action="step-one-linkedin-sign-in"
                    type="button"
                    class="linkedin-sign-in"
                    id="linkedinBtn"
                    (click)="linkedinSignUpSelection()"
                    data-testid="sign-up-linkedin"
                    >
                    <img
                      src="https://storage.googleapis.com/galaxy-libs-public-images/linkedin-bug.svg"
                      class="linkedin-logo"
                      alt="LinkedIn Logo"
                      />
                    <span class="linkedin-sign-in-text">
                      {{ 'SIGNUP.BUTTONS.LINKEDIN' | translate }}
                    </span>
                  </button>
                </span>
              } @else {
                <mat-progress-spinner mode="indeterminate" diameter="26"></mat-progress-spinner>
              }
            </div>
            <div class="row sign-up-divider" [class.googleHide]="googleOptionSelected$$ | async">
              <div>
                {{ 'SIGNUP.OR' | translate }}
              </div>
            </div>
          </div>
        }
        <div class="row" [class.googleHide]="googleOptionSelected$$ | async">
          <glxy-form-field appearance="outline" style="width: 100%">
            <glxy-label>{{ 'SIGNUP.EMAIL' | translate }}</glxy-label>
            <input
              #emailInput
              [placeholder]="'SIGNUP.EMAIL' | translate"
              [formControl]="form.get('email')"
              type="email"
              id="email"
              matInput
              email="true"
              name="email"
              required
              data-testid="email-input"
              />
            @if (form.dirty && form.get('email')?.invalid) {
              <glxy-error data-testid="email-error">
                @if (form.get('email')?.errors?.unknownError) {
                  <div>
                    {{ 'SIGNUP.VALIDATION.UNKNOWN_ERROR' | translate }}
                  </div>
                }
                @if (form.get('email')?.errors?.required) {
                  <div>
                    {{ 'COMMON.FIELD_REQUIRED' | translate: { fieldName: 'SIGNUP.EMAIL' | translate } }}
                  </div>
                }
                @if (form.get('email')?.errors?.forbiddenEmail) {
                  <div>
                    {{ 'SIGNUP.VALIDATION.NO_VENDASTA_EMAIL' | translate }}
                  </div>
                }
                @if (form.get('email')?.errors?.email || form.get('email')?.errors?.invalidEmail) {
                  <div>
                    {{ 'SIGNUP.VALIDATION.VALID_EMAIL' | translate }}
                  </div>
                }
                @if (form.get('email')?.errors?.emailInUse) {
                  <div>
                    {{ 'SIGNUP.VALIDATION.EMAIL_IN_USE' | translate }}
                  </div>
                }
                @if (form.get('email')?.errors?.emailInUsePartner) {
                  <div
                    [innerHTML]="'SIGNUP.VALIDATION.EMAIL_IN_USE_PARTNER' | translate: { loginURL: loginURL }"
                  ></div>
                }
                @if (form.get('email')?.errors?.disposableEmail) {
                  <div>
                    {{ 'SIGNUP.VALIDATION.DISPOSABLE_EMAIL' | translate }}
                  </div>
                }
                @if (form.get('email')?.errors?.nonHackerOneEmail) {
                  <div>
                    {{ 'SIGNUP.VALIDATION.NON_HACKERONE_EMAIL' | translate }}
                  </div>
                }
              </glxy-error>
            }
          </glxy-form-field>
        </div>
        <div class="sign-up-form-cta-container" [class.googleHide]="googleOptionSelected$$ | async">
          @if (recaptchaV2isEmailInUse) {
            <re-captcha
              class="sign-up-form-recaptchaV2"
              #captchaRef="reCaptcha"
              [siteKey]="recaptchaSiteKey"
              (resolved)="resolvedRecaptchaV2isEmailInUse($event)"
            ></re-captcha>
          }
          @if (emailFormStatus$$ | async; as emailFormStatus) {
            <button
              data-action="step-one-email-sign-in"
              class="sign-up-form-cta full-width"
              mat-flat-button
              color="primary"
              type="button"
              [disabled]="emailFormStatus === 'PENDING'"
              (click)="onSubmitStepOne()"
              data-testid="email-or-google-next"
              >
              {{ 'SIGNUP.BUTTONS.NEXT' | translate }}
            </button>
          }
        </div>
        <div class="sign-up-form-privacy-policy">
          {{ 'SIGNUP.TOS_TOS_PRELINK' | translate }}
          <a data-action="step-one-tos" href="https://www.vendasta.com/terms/terms-of-service/" target="_blank">
            {{ 'SIGNUP.TOS_TOS_LINK' | translate }}
          </a>
          <span class="link-separator">,</span>
          <a data-action="step-one-privacy" href="https://www.vendasta.com/privacy-policy" target="_blank">
            {{ 'SIGNUP.TOS_PRIVACY_POLICY_LINK' | translate }}
          </a>
          {{ 'SIGNUP.TOS_BETWEEN_LINKS' | translate }}
          <a data-action="step-one-cookie" href="https://www.vendasta.com/cookie-policy/" target="_blank">
            {{ 'SIGNUP.TOS_COOKIE_POLICY_LINK' | translate }}
          </a>
          <span class="link-separator">.</span>
          <span [innerHTML]="'SIGNUP.RECAPTCHA_BRANDING' | translate"></span>
        </div>
      </div>
    </div>
  </div>
</div>
